export const PROPS = {
  isDelegationCode: {
    type: Boolean,
    default: false
  },
  examProgress: {
    type: Number,
    default: 0
  },
  maximumPprogress: {
    type: Number,
    default: 0
  },
  examTotalCount: {
    type: Number,
    default: 0
  },
  questAmount: {
    type: Number,
    default: 0
  },
  haveGet: {
    type: Number,
    default: 0
  },
  isExpired: {
    type: Boolean,
    default: false
  },
  acceptDelegation: {
    type: Boolean,
    default: false
  },
  isAcceptDelegation: {
    type: Boolean,
    default: false
  },
  codeId: {
    type: String,
    default: ''
  }
}
